// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zgXA","largestCol":"styles_largestCol__2w4jI","smallestCol":"styles_smallestCol__363rh"};